import { memo } from "react"
import { useAuth } from "contexts/auth"
import GuestCheckout from "./guest"
import MemberCheckout from "./member"

const Checkout = () => {
    const { user } = useAuth();
    return user ? <MemberCheckout /> : <GuestCheckout />;
}

export default memo(Checkout)
